export default function(text, fileName) {
  const data = new Blob([text], { type: "text/plain" });
  // IE & Edge fix for downloading blob files, gives option to save or open the file when the link is opened.
  if (navigator && navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(data, fileName);
  } else {
    var element = document.createElement("a");
    element.setAttribute("href", URL.createObjectURL(data));
    element.setAttribute("download", fileName);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}
